import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalBulletinsInput,
  terminalBulletinsInputSchema,
} from "./shared/terminalBulletins.input";
import {
  type TerminalBulletin,
  terminalBulletinSchema,
} from "./shared/terminalBulletins.output";

/**
 * Metadata for the fetchTerminalBulletins endpoint
 */
export const terminalBulletinsMeta = {
  functionName: "fetchTerminalBulletins",
  endpoint: "/terminalBulletins",
  inputSchema: terminalBulletinsInputSchema,
  outputSchema: terminalBulletinSchema.array(),
  sampleParams: {},
  endpointDescription: "List bulletins and alerts for all terminals.",
} satisfies EndpointMeta<TerminalBulletinsInput, TerminalBulletin[]>;

/**
 * Fetch function for retrieving bulletins and alerts for all terminals
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalBulletinsInput,
  TerminalBulletin[]
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalBulletinsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalBulletins.endpoints").terminalBulletinsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving bulletins and alerts for all terminals
 */
export const fetchTerminalBulletins: FetchFactory<
  TerminalBulletinsInput,
  TerminalBulletin[]
> = fetch;

/**
 * React Query hook for retrieving bulletins and alerts for all terminals
 */
export const useTerminalBulletins: HookFactory<
  TerminalBulletinsInput,
  TerminalBulletin[]
> = useHook;
